<div class="column spacing-24" style="padding-bottom: 72px">
	<app-not-authorized-notice
		[hasOne]="['companyRelationshipManagement', 'globalCompanyManagement']"
	></app-not-authorized-notice>

	@if (!isExistingCompany) {
		<div
			class="content-container"
			[appHasSystemCapability]
			[hasOne]="['companyRelationshipManagement', 'globalCompanyManagement']"
		>
			<div class="content-container-header">
				<h3><b i18n="@@addCompanyAbout-createNewCompanyHeader">Details about the Company</b></h3>
				<p i18n="@@addCompanyAbout-createNewCompanyDescription">
					The following information will be added to the public directory.
				</p>
			</div>
			<mat-divider></mat-divider>
			<div class="content-container-body column spacing-24">
				<div class="row spacing-24">
					<mat-form-field subscriptSizing="dynamic" class="column-double" appearance="outline">
						<mat-label class="mat-label-color" i18n="@@addCompanyAbout-createNewCompanyName">Name</mat-label>
						<input
							data-automation-id="name-input"
							matInput
							[disabled]="isExistingCompany"
							[(ngModel)]="name"
							autofocus
							required
						/>
					</mat-form-field>
					<div class="column"></div>
				</div>
				<div class="row spacing-24">
					<mat-form-field subscriptSizing="dynamic" class="column" appearance="outline" [hideRequiredMarker]="true">
						<mat-label class="mat-label-color" i18n="@@addCompanyAbout-createNewCompanyCountry"
							>Country
							<span class="asterisk-symbol" data-automation-id="companyAbout-countryInput-required">*</span></mat-label
						>
						<input
							matInput
							data-automation-id="country-input"
							type="text"
							[disabled]="isExistingCompany"
							aria-label="Country"
							[matAutocomplete]="auto"
							name="countryCode"
							autocomplete="countryCode"
							required
							[(ngModel)]="countryCode"
							(ngModelChange)="filterCountries($event)"
							(click)="openAutocompleteCountries()"
							(input)="countryInput()"
							(blur)="validateTaxId()"
						/>
						<mat-autocomplete
							#auto="matAutocomplete"
							[displayWith]="displayCountryName"
							(optionSelected)="countrySelected()"
							data-automation-id="country-picker"
						>
							@for (country of filteredCountries | async; track country.twoLetterCode) {
								<mat-option
									[value]="country.twoLetterCode"
									[attr.data-automation-id]="'country-option-' + country.twoLetterCode"
								>
									{{ country.name }}
								</mat-option>
							}
						</mat-autocomplete>
						@if (showCountryError) {
							<mat-hint i18n="@@addCompanyAbout-createNewCompanyCountryError" data-automation-id="country-error">
								Please select a Country from the list
							</mat-hint>
						}
					</mat-form-field>
					<mat-form-field subscriptSizing="dynamic" class="column" appearance="outline">
						<mat-label class="mat-label-color" i18n="@@addCompanyAbout-createNewCompanyTaxID">Tax ID</mat-label>
						<input
							matInput
							[disabled]="isExistingCompany"
							[(ngModel)]="taxId"
							required
							data-automation-id="tax-id-input"
							name="taxId"
							#taxIdModel="ngModel"
							(blur)="validateTaxId()"
						/>
						@if (foundTaxIdDuplicate) {
							<mat-hint
								class="found-duplicate-error-msg"
								i18n="@@addCompanyAbout-duplicateTaxIdInCompany"
								data-automation-id="status-error"
								>A company with this Tax ID already exists.</mat-hint
							>
						}
					</mat-form-field>
					<mat-form-field subscriptSizing="dynamic" class="column" appearance="outline">
						<mat-label class="mat-label-color" i18n="@@addCompanyAbout-createNewCompanyStatus">Status</mat-label>
						<mat-select
							disableOptionCentering
							[disabled]="isExistingCompany"
							[(ngModel)]="active"
							data-automation-id="status-picker"
						>
							@for (option of activeOptions; track option) {
								<mat-option [value]="option.value" [attr.data-automation-id]="'status-option-' + option.label">{{
									option.label
								}}</mat-option>
							}
						</mat-select>
					</mat-form-field>
					@if (foundDuplicate) {
						<mat-error
							class="found-duplicate-error-msg"
							i18n="@@addCompanyAbout-duplicateCompanyMessage"
							data-automation-id="status-error"
							>Attempted duplicate entry; please check public directory to find this company.</mat-error
						>
					}
				</div>
				<div class="row spacing-24">
					<mat-form-field subscriptSizing="dynamic" class="column" appearance="outline" [hideRequiredMarker]="true">
						<mat-label class="mat-label-color" i18n="@@addCompanyAbout-Timezone"
							>Timezone
							<span class="asterisk-symbol" data-automation-id="companyAbout-timezoneInput-required">*</span></mat-label
						>
						<input
							type="text"
							aria-label="Timezone"
							matInput
							[disabled]="isExistingCompany"
							[matAutocomplete]="autoTimezone"
							name="timezone"
							autocomplete="timezone"
							required
							[(ngModel)]="timezone"
							(ngModelChange)="filterTimezones($event)"
							(click)="openAutocompleteTimezones()"
							(input)="timezoneInput()"
							data-automation-id="timezone-input"
						/>
						<mat-autocomplete
							#autoTimezone="matAutocomplete"
							[displayWith]="displayTimezoneName"
							(optionSelected)="timezoneSelected()"
							data-automation-id="timezone-picker"
						>
							@for (filteredTimezone of filteredTimezones | async; track filteredTimezone.timezone) {
								<mat-option
									[value]="filteredTimezone.timezone"
									[attr.data-automation-id]="'timezone-option-' + filteredTimezone.timezone"
								>
									{{ filteredTimezone.timezone }} - {{ filteredTimezone.description }}
								</mat-option>
							}
						</mat-autocomplete>
						@if (showTimezoneError) {
							<mat-hint i18n="@@addCompanyAbout-createNewCompanyTimezoneError" data-automation-id="timezone-error">
								Please select a Timezone from the list
							</mat-hint>
						}
					</mat-form-field>
					<div class="column"></div>
					<div class="column"></div>
				</div>
				<mat-divider></mat-divider>
				<div class="row spacing-24">
					<mat-form-field subscriptSizing="dynamic" class="column" appearance="outline">
						<mat-label class="mat-label-color" i18n="@@addCompanyAbout-createNewCompanyAddress">Address</mat-label>
						<input
							matInput
							[disabled]="isExistingCompany"
							[(ngModel)]="streetName"
							data-automation-id="address-input"
						/>
					</mat-form-field>
					<mat-form-field subscriptSizing="dynamic" class="column" appearance="outline">
						<mat-label class="mat-label-color" i18n="&quot;@@addCompanyAbout-createNewCompanyApartment"
							>Apartment / Suite</mat-label
						>
						<input
							matInput
							[disabled]="isExistingCompany"
							[(ngModel)]="apartmentSuite"
							data-automation-id="apartment-input"
						/>
					</mat-form-field>
					<mat-form-field subscriptSizing="dynamic" class="column" appearance="outline">
						<mat-label class="mat-label-color" i18n="@@addCompanyAbout-createNewCompanyTown">Town / City</mat-label>
						<input matInput [disabled]="isExistingCompany" [(ngModel)]="townCity" data-automation-id="town-input" />
					</mat-form-field>
				</div>
				<div class="row spacing-24">
					<mat-form-field subscriptSizing="dynamic" class="column" appearance="outline">
						<mat-label class="mat-label-color" i18n="@@addCompanyAbout-createNewCompanyState"
							>State / Province</mat-label
						>
						<input
							matInput
							[disabled]="isExistingCompany"
							[(ngModel)]="stateProvince"
							data-automation-id="state-input"
						/>
					</mat-form-field>
					<mat-form-field subscriptSizing="dynamic" class="column" appearance="outline">
						<mat-label class="mat-label-color" i18n="@@addCompanyAbout-createNewCompanyZip"
							>Zip / Postal Code</mat-label
						>
						<input matInput [disabled]="isExistingCompany" [(ngModel)]="zipPostalCode" data-automation-id="zip-input" />
					</mat-form-field>
				</div>
			</div>
		</div>
	}

	@if (isExistingCompany) {
		<div
			class="content-container edit-toggle-page"
			[appHasSystemCapability]
			[hasOne]="['companyRelationshipManagement', 'globalCompanyManagement']"
		>
			<div class="content-container-header">
				<h3><b i18n="@@addCompanyAbout-viewCompanyHeader">Details about the Company</b></h3>
			</div>
			<mat-divider></mat-divider>
			<div class="content-container-body column spacing-24">
				<div class="row">
					<div class="row top-bottom-padding">
						<table style="width: 100%">
							<tr class="mat-body-2">
								<td class="width-25-grey" i18n="@@addCompanyAbout-viewCountry">Country</td>
								<td class="width-25-grey" i18n="@@addCompanyAbout-viewTaxID">Tax ID</td>
								<td class="width-25-grey" i18n="@@addCompanyAbout-viewStatus">Status</td>
								<td class="width-25">&nbsp;</td>
							</tr>
							<tr class="mat-body-3">
								<td class="table-body-text">{{ editCompany.company.address?.countryCode }}</td>
								<td class="table-body-text">{{ editCompany.company.taxId }}</td>
								<td class="table-body-text">
									<mat-chip-set>
										<mat-chip class="status-chip" [ngClass]="getChipStyling(editCompany.company.active ?? false)"
											>&bull;&NonBreakingSpace;{{ displayStatusName(editCompany.company.active ?? false) }}</mat-chip
										>
									</mat-chip-set>
								</td>
							</tr>
						</table>
					</div>
				</div>
				<mat-divider></mat-divider>
				<div class="row">
					<div class="row top-bottom-padding">
						<table style="width: 100%">
							<tr class="mat-body-2">
								<td class="width-25-grey" i18n="@@addCompanyAbout-viewStreetAddress">Street Address</td>
								<td class="width-25-grey" i18n="@@addCompanyAbout-viewApartmentSuite">Apartment/Suite (optional)</td>
								<td class="width-25">&nbsp;</td>
								<td class="width-25">&nbsp;</td>
							</tr>
							<tr class="mat-body-3">
								<td class="table-body-text">{{ editCompany.company.address?.address1 }}</td>
								<td class="table-body-text">{{ editCompany.company.address?.address2 }}</td>
							</tr>
						</table>
					</div>
					<div class="row top-bottom-padding">
						<table style="width: 100%">
							<tr class="mat-body-2">
								<td class="width-25-grey" i18n="@@addCompanyAbout-viewTownCity">Town/City</td>
								<td class="width-25-grey" i18n="@@addCompanyAbout-viewStateProvince">State/Province</td>
								<td class="width-25-grey" i18n="@@addCompanyAbout-viewPostalCode">Postal Code</td>
								<td class="width-25">&nbsp;</td>
							</tr>
							<tr class="mat-body-3">
								<td class="table-body-text">{{ editCompany.company.address?.locality }}</td>
								<td class="table-body-text">{{ editCompany.company.address?.stateProvinceRegion }}</td>
								<td class="table-body-text">{{ editCompany.company.address?.postalCode }}</td>
							</tr>
						</table>
					</div>
				</div>
			</div>
		</div>
	}

	@if (!isExistingCompany) {
		<div [appHasSystemCapability] [hasOne]="['companyRelationshipManagement', 'globalCompanyManagement']">
			<app-user-search-bar
				[searchAllUsers]="true"
				(selectedUserEvents)="onUserSelectedEvent($event)"
				[headerText]="addUserHeaderText"
				[descriptionText]="addUserDescriptionText"
			></app-user-search-bar>
		</div>
	}

	<div
		class="content-container"
		[appHasSystemCapability]
		[hasOne]="['companyRelationshipManagement', 'globalCompanyManagement']"
	>
		<div class="content-container-header">
			<h3><b i18n="@@addCompanyAbout-companyRelationship">Company Relationship</b></h3>
			<p i18n="@@addCompanyAbout-companyRelationshipDescription">
				The following information will be private to your company.
			</p>
		</div>

		<mat-divider style="margin-top: 10px; margin-bottom: 10px"></mat-divider>

		<div class="content-container-body column spacing-24">
			<mat-form-field subscriptSizing="dynamic" appearance="outline" class="filter-row-child-third">
				<mat-label i18n="@@addCompanyAbout-relationshipType">Type</mat-label>
				<mat-select
					disableOptionCentering
					[(ngModel)]="editCompany.relationshipType"
					required
					data-automation-id="relationship-type-picker"
				>
					<mat-option value="client" i18n="@@addCompanyAbout-typeClient" data-automation-id="relationship-type-client"
						>Client</mat-option
					>
					<mat-option
						value="contractor"
						i18n="@@addCompanyAbout-typeContractor"
						data-automation-id="relationship-type-contractor"
						>Contractor</mat-option
					>
				</mat-select>
			</mat-form-field>

			<mat-form-field subscriptSizing="dynamic" appearance="outline" class="filter-row-child-third">
				<mat-label i18n="@@addCompanyAbout-customCompanyIdLabel">Custom Company ID</mat-label>
				<input matInput [(ngModel)]="editCompany.detail.externalId" data-automation-id="company-id-input" />
			</mat-form-field>

			<div class="row">
				<mat-form-field subscriptSizing="dynamic" appearance="outline" style="flex: 1">
					<mat-label i18n="@@addCompanyAbout-NotesLabel">Notes</mat-label>
					<textarea matInput [(ngModel)]="editCompany.detail.notes" data-automation-id="notes-textarea"></textarea>
				</mat-form-field>

				<div class="filter-row-child-third"></div>
			</div>

			@if (isSentriKeyAccessUser) {
				<div>
					<h3 i18n="@@addCompanyAbout-companyType" data-automation-id="addCompanyAbout-companyType">Company Type</h3>
					<div class="row">
						<mat-radio-group
							class="thin-outline-radio-button-group two-col-radio-group"
							[(ngModel)]="companyTypeValue"
							[disabled]="isExistingCompany"
							(change)="onCompanyTypeChange($event)"
							required
							data-automation-id="company-type-group"
							style="flex: 1"
						>
							<mat-radio-button value="advanced" data-automation-id="company-type-advanced">
								<div>
									<h3
										i18n="@@addCompanyAbout-companyTypeStandard"
										data-automation-id="addCompanyAbout-companyTypeStandard"
									>
										Standard
									</h3>
								</div>
								<p
									i18n="@@addCompanyAbout-companyTypeStandardDesc"
									data-automation-id="addCompanyAbout-companyTypeStandardDesc"
								>
									Full-feature management for large organizations with multiple sub-companies.
								</p>
							</mat-radio-button>
							<mat-radio-button value="care" data-automation-id="company-type-care">
								<div>
									<h3 i18n="@@addCompanyAbout-companyTypeCare" data-automation-id="addCompanyAbout-companyTypeCare">
										Care
									</h3>
								</div>
								<p
									i18n="@@addCompanyAbout-companyTypeCareDesc"
									data-automation-id="addCompanyAbout-companyTypeCareDesc"
								>
									Dedicated access management for home health and patient care professionals.
								</p>
							</mat-radio-button>
						</mat-radio-group>
						<div class="filter-row-child-third"></div>
					</div>
				</div>
			}
		</div>
	</div>

	<div
		class="content-container"
		[appHasSystemCapability]
		[hasOne]="['companyRelationshipManagement', 'globalCompanyManagement']"
	>
		<div class="content-container-header">
			<h3><b i18n="@@addCompanyAbout-companySettings">Company Settings</b></h3>
			<p i18n="@@addCompanyAbout-companySettingsDescription">Allows users to customize and manage company settings.</p>
		</div>

		<mat-divider style="margin-top: 10px; margin-bottom: 10px"></mat-divider>

		<div class="content-container-body column spacing-24">
			<!-- Alerts & Notifications -->
			@if (hasAlertsAndNotificationsContent()) {
				<section class="company-settings-section">
					<h4 class="company-settings-section-header" i18n="@@addCompanyAbout-alertsAndNotifications">
						Alerts & Notifications
					</h4>
					<div class="company-settings-section-body column spacing-24">
						@if ((editCompany.company.keyDetection && !isOracle) || isOracle) {
							<div class="row">
								<div class="column">
									<p i18n="@@addCompanyAbout-companySettingsKeyDetection">Key Detection</p>
								</div>
								<div class="column">
									<mat-slide-toggle
										[(ngModel)]="editCompany.company.keyDetection"
										[disabled]="!isOracle"
										(change)="keyDetectionChanged($event)"
										data-automation-id="key-detection-toggle"
									></mat-slide-toggle>
								</div>
								<div class="column"></div>
							</div>
						}
						@if (isOracle) {
							<div class="row">
								<div class="column">
									<p i18n="@@addCompanyAbout-companySettingsSmsSwitch">Allow SMS Notifications</p>
								</div>
								<div class="column">
									<mat-slide-toggle
										[(ngModel)]="editCompany.company.smsNotifications"
										[disabled]="!isOracle"
										data-automation-id="sms-toggle"
									></mat-slide-toggle>
								</div>
								<div class="column"></div>
							</div>
						}
						@if (isSentriKeyAccessUser) {
							<div class="row">
								<div class="column">
									<p
										[class.contact-notifications-label-disabled]="!isContactNotificationsEnabled()"
										i18n="@@addCompanyAbout-companySettingsContactNotifications"
									>
										Contact Notifications
									</p>
								</div>
								<div class="column">
									<mat-slide-toggle
										[(ngModel)]="editCompany.company.contactNotifications"
										[disabled]="!isContactNotificationsEnabled()"
										data-automation-id="contact-notifications-toggle"
									></mat-slide-toggle>
								</div>
								<div class="column"></div>
							</div>
						}
					</div>
				</section>
			}

			<!-- Device Management -->
			@if (hasDeviceManagementContent()) {
				<section class="company-settings-section">
					<h4 class="company-settings-section-header" i18n="@@addCompanyAbout-deviceManagement">Device Management</h4>
					<div class="company-settings-section-body column spacing-24">
						@if (isOracle) {
							<div class="row">
								<div class="column">
									<p i18n="@@addCompanyAbout-deviceRemovalAccessOptions">Device Removal Access Options</p>
								</div>
								<div class="column">
									<mat-slide-toggle
										[(ngModel)]="editCompany.company.deviceRemovalAccessOptions"
										[disabled]="!isOracle"
										data-automation-id="device-removal-access-options-toggle"
									></mat-slide-toggle>
								</div>
								<div class="column"></div>
							</div>
						}
						@if (isOracle) {
							<div class="row">
								<div class="column">
									<p
										i18n="@@addCompanyAbout-companySettingsRequireReasonForCodeGeneration"
										data-automation-id="companySettings-requireReasonForCodeGenerationStaticText"
									>
										Require Reason for Code Generation
									</p>
								</div>
								<div class="column">
									<mat-slide-toggle
										[(ngModel)]="editCompany.company.requireReasonForCodeGeneration"
										[disabled]="!isOracle"
										(change)="keyDetectionChanged($event)"
										data-automation-id="companySettings-requireReasonForCodeGenerationToggle"
									></mat-slide-toggle>
								</div>
								<div class="column"></div>
							</div>
						}
					</div>
				</section>
			}

			<!-- Privacy & Compliance -->
			<section class="company-settings-section">
				<h4 class="company-settings-section-header" i18n="@@addCompanyAbout-privacyAndCompliance">
					Privacy & Compliance
				</h4>
				<div class="company-settings-section-body column spacing-24">
					@if ((editCompany.company.hideFromPublicDirectory && !isOracle) || isOracle) {
						<div class="row">
							<div class="column">
								<p
									i18n="@@addCompanyAbout-companySettingsHideFromPublicDirectory"
									data-automation-id="companySettings-HideFromPublicDirectoryStaticText"
								>
									Hide from Public Directory
								</p>
							</div>
							<div class="column">
								<mat-slide-toggle
									[(ngModel)]="editCompany.company.hideFromPublicDirectory"
									[disabled]="!isOracle"
									(change)="keyDetectionChanged($event)"
									data-automation-id="companySettings-HideFromPublicDirectoryToggle"
								></mat-slide-toggle>
							</div>
							<div class="column"></div>
						</div>
					}

					<div class="row">
						<div class="column">
							<p i18n="@@addCompanyAbout-companySettingsDeidentification">
								What is the time frame before the company undergoes de-identification?
							</p>
						</div>
						<div class="column">
							<mat-form-field
								subscriptSizing="dynamic"
								appearance="outline"
								class="filter-row-child-third input-container-width-200"
							>
								<mat-label i18n="@@addCompanyAbout-deidentificationMonths">Months</mat-label>
								<input
									matInput
									type="number"
									[(ngModel)]="editCompany.company.deidentification"
									required
									min="1"
									max="48"
									[disabled]="!isOracle"
									data-automation-id="month-input"
								/>
								<mat-error i18n="@@addCompanyAbout-deidentificationMonthsError" data-automation-id="month-error"
									>The value entered is invalid. Please enter a value between 1 and 48</mat-error
								>
							</mat-form-field>
						</div>
						<div class="column"></div>
					</div>
				</div>
			</section>

			<!-- System Integrations -->
			@if (hasSystemIntegrationsContent()) {
				<section class="company-settings-section">
					<h4 class="company-settings-section-header" i18n="@@addCompanyAbout-systemIntegrations">
						System Integrations
					</h4>
					<div class="company-settings-section-body column spacing-24">
						@if (isSentriKeyAccessUser) {
							<div class="row">
								<div class="column">
									<p i18n="@@addCompanyAbout-ajaxIntegration">AJAX Integration</p>
								</div>
								<div class="column">
									<mat-slide-toggle
										[(ngModel)]="editCompany.company.ajaxEnabled"
										data-automation-id="ajax-integration-toggle"
									></mat-slide-toggle>
								</div>
								<div class="column"></div>
							</div>
						}
						@if (isSentriKeyAccessUser && editCompany.company.ajaxEnabled) {
							<div class="row">
								<div class="column width-100-grey small-margin-left">
									<p i18n="@@addCompanyAbout-ajaxIntegrationUsername">Username</p>
								</div>
								<div class="column limit-ajax-height-input">
									<mat-form-field
										subscriptSizing="dynamic"
										appearance="outline"
										class="filter-row-child-third input-container-width-200"
										[formGroup]="ajaxFormGroup"
									>
										<mat-label i18n="@@addCompanyAbout-userUsername">Username</mat-label>
										<input
											matInput
											formControlName="ajaxUsername"
											data-automation-id="ajax-user-id-input"
											autocomplete="new-password"
											(input)="onAjaxUsernameChange()"
										/>
									</mat-form-field>
								</div>
								<div class="column"></div>
							</div>
						}
						@if (isSentriKeyAccessUser && editCompany.company.ajaxEnabled) {
							<div class="row">
								<div class="column width-100-grey small-margin-left">
									<p i18n="@@addCompany-ajaxIntegrationPassword">Password</p>
								</div>
								<div class="column">
									<mat-form-field
										appearance="outline"
										class="filter-row-child-third input-container-width-200"
										subscriptSizing="dynamic"
										[formGroup]="ajaxFormGroup"
										[floatLabel]="
											ajaxFormGroup.get('ajaxPassword')?.invalid && ajaxFormGroup.get('ajaxPassword')?.touched
												? 'always'
												: 'auto'
										"
									>
										<mat-label i18n="@@addCompanyAbout-password">Password</mat-label>
										<input
											matInput
											formControlName="ajaxPassword"
											[type]="hidePwd ? 'password' : 'text'"
											data-automation-id="password-input"
											autocomplete="new-password"
										/>
										<mat-icon
											matSuffix
											(click)="hidePwd = !hidePwd"
											data-automation-id="hide-pwd-ajax-button"
											class="hidden-icon"
											>{{ hidePwd ? 'visibility_off' : 'visibility' }}</mat-icon
										>
									</mat-form-field>
								</div>
								<div class="column"></div>
							</div>
						}
						@if (isOracle) {
							<div class="row">
								<div class="column">
									<p i18n="@@addCompanyAbout-companySettingsApiEnabled">Will the company be using our API?</p>
								</div>
								<div class="column">
									<mat-slide-toggle
										[(ngModel)]="editCompany.company.apiEnabled"
										[disabled]="!isOracle"
										data-automation-id="api-toggle"
									></mat-slide-toggle>
								</div>
								<div class="column"></div>
							</div>
						}
						@if (isOracle) {
							<div class="row">
								<div class="column kong-usernames-field-wrapper">
									<mat-form-field subscriptSizing="dynamic" appearance="outline" class="kong-usernames-full-width">
										<mat-label i18n="@@addCompanyAbout-kongUsernames" data-automation-id="kong-usernames-label"
											>Kong Usernames (exact match)</mat-label
										>
										<textarea
											class="api-usernames-box"
											matInput
											[(ngModel)]="editCompany.editApiUsernames"
											[disabled]="!isOracle || !editCompany.company.apiEnabled"
											rows="5"
											i18n-placeholder="@@addCompanyAbout-companySettingsApiUsernamesPlaceholder"
											data-automation-id="kong-usernames-textarea"
											[required]="!!editCompany.company.apiEnabled"
										>
										</textarea>
									</mat-form-field>
								</div>
								<div class="column"></div>
								<div class="column"></div>
							</div>
						}
					</div>
				</section>
			}
		</div>
	</div>
</div>
